"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const putContributionsData = graphql_tag_1.default `
  mutation($environmentId: String!, $type: String!, $agentId: String!, $data: String!) {
    putContributionsData(environmentId: $environmentId, type: $type, agentId: $agentId, data: $data) {
      id
      environmentId
      type
      agentId
      contribution
      data
    }
  }
`;
exports.default = putContributionsData;
//# sourceMappingURL=putContributionsData.js.map